<template>
  <div class="card">
    <div class="card-header">
      <div class="col-left">
        <div class="row">
          <router-link
            class="title"
            :to="{
              name: 'content',
              params: {
                id,
              },
            }"
          >
            {{ title }}
          </router-link>
          <stars :stars="stars" />
          <div
            v-if="roomsList && roomsList.length > 0"
            class="matches"
          >
            {{ roomsList.length > 1 ? `${roomsList.length} matches` : '1 match' }}
          </div>
        </div>
        <location>{{ location }}</location>
      </div>
      <div class="col-right">
        <div
          v-if="taImage && taImage !== 'NULL'"
          class="tripadvisor"
        >
          <img
            :src="taImage"
            :alt="`${taRating}`"
          >
        </div>
      </div>
    </div>
    <results-card
      v-for="room in roomsList"
      :key="room.id"
      v-bind="room"
      :hotel-id="id"
      :room-level="true"
    />
  </div>
</template>

<script>
import Stars from './tiny/Stars';
import Location from './tiny/Location';
import ResultsCard from './SearchResultsCard';

export default {
  name: 'search-results-card-room',
  components: {
    Stars,
    ResultsCard,
    Location,
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    stars: {
      type: Number,
      required: true,
    },
    location: {
      type: String,
      required: true,
    },
    taImage: {
      type: String,
      default: null,
    },
    taRating: {
      type: [Number, String],
      default: null,
    },
    roomsList: {
      type: Array,
      default: null,
    },
  },
};
</script>

<style scoped lang="scss">
.card {
  margin-bottom: 24px;
  padding: 16px;
  border-radius: 4px;
  text-align: left;
  font-size: 13px;
  color: #6e7c91;
  background-color: #fff;
  box-shadow: 0 6px 25px 4px rgba(114, 132, 160, 0.18);

  &-header {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    & + * {margin-top: 10px;}
    @media (min-width: 1200px) {
      flex-direction: row;
    }

    .col-left {
      @media (min-width: 1200px) {
        margin-right: 8px;
      }
    }

    .row {
      display: flex;
      align-items: center;
      & + * {margin-top: 5px;}
    }

    .title {
      color: #32325a;
      text-decoration: none;
      font-size: 17px;
      font-weight: bold;
      .no-touchevents &:hover {
        text-decoration: underline;
      }
      &:active {
        text-decoration: underline;
      }
    }

    .matches {
      white-space: nowrap;
      margin-left: 10px;
      padding: 6px 8px;
      border-radius: 2px;
      font-size: 10px;
      font-weight: 700;
      color: #3cbf68;
      letter-spacing: -0.2px;
      background-color: rgba(#17cd53, 0.2);
    }

    .tripadvisor {
      margin-top: 12px;
      height: 15px;
      img {
        display: block;
        height: 100%;
        width: auto;
      }
    }
  }

  .stars {
    margin: 3px 0 3px 10px;
  }
}
</style>
